export { default } from './StarRatingDisplay'
